/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstBooleanOpts, SchemaConstBoolean, ISchemaConstBoolean } from "../const/SchemaConstBoolean";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueBooleanOpts extends ISchemaValueOpts<ISchemaConstBoolean>, ISchemaConstBooleanOpts {}

/**
 * Schema: Boolean value
 *
 * @param opts Schema options
 */
export function SchemaValueBoolean(opts: ISchemaValueBooleanOpts): ISchemaValue<ISchemaConstBoolean> {

	return SchemaValue(SchemaConstBoolean(opts), opts);

}